"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderSelector = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const utils_1 = require("@/utils");
require("@/components/common/toggle-button/toggle-button-group");
let GenderSelector = class GenderSelector extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = 'other';
        this.stretch = false;
        this.options = [
            { value: 'other', label: '기타' },
            { value: 'female', label: '여성' },
            { value: 'male', label: '남성' },
        ];
    }
    render() {
        return (0, lit_1.html) `
      <mm-toggle-button-group
        aria-label="성별"
        .options=${this.options}
        .value=${this.value}
        ?stretch=${this.stretch}
        @change=${this.handleGenderChange}
      ></mm-toggle-button-group>
    `;
    }
    handleGenderChange(event) {
        event.stopPropagation();
        this.value = event.detail.value;
        (0, utils_1.emit)(this, 'change', { value: this.value });
    }
};
GenderSelector.styles = (0, lit_1.css) `
    :host {
      display: inline-block;
    }

    :host([stretch]) {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], GenderSelector.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], GenderSelector.prototype, "stretch", void 0);
GenderSelector = __decorate([
    (0, decorators_js_1.customElement)('mm-gender-selector')
], GenderSelector);
exports.GenderSelector = GenderSelector;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZGVyLXNlbGVjdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZ2VuZGVyLXNlbGVjdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFJM0QsbUNBQThCO0FBQzlCLGlFQUE4RDtBQUt2RCxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFBdkM7O1FBVXVCLFVBQUssR0FBVyxPQUFPLENBQUE7UUFDUCxZQUFPLEdBQUcsS0FBSyxDQUFBO1FBQzFDLFlBQU8sR0FBaUI7WUFDdkMsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUU7WUFDL0IsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUU7WUFDaEMsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUU7U0FDL0IsQ0FBQTtJQW1CSCxDQUFDO0lBakJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7bUJBR0ksSUFBSSxDQUFDLE9BQU87aUJBQ2QsSUFBSSxDQUFDLEtBQUs7bUJBQ1IsSUFBSSxDQUFDLE9BQU87a0JBQ2IsSUFBSSxDQUFDLGtCQUFrQjs7S0FFcEMsQ0FBQTtJQUNILENBQUM7SUFFTyxrQkFBa0IsQ0FBQyxLQUFxQztRQUM5RCxLQUFLLENBQUMsZUFBZSxFQUFFLENBQUE7UUFDdkIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQTtRQUMvQixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsUUFBUSxFQUFFLEVBQUUsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFBO0lBQzdDLENBQUM7O0FBakNNLHFCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O0dBUWxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzZDQUF3QjtBQUNQO0lBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOytDQUFnQjtBQVhoRCxjQUFjO0lBRDFCLElBQUEsNkJBQWEsRUFBQyxvQkFBb0IsQ0FBQztHQUN2QixjQUFjLENBbUMxQjtBQW5DWSx3Q0FBYyJ9